import { initSetLogo } from './helpers.js';

export const setLogo = (src) => initSetLogo('.reg-logo__img', 'reg-logo__img_hidden', src);

export function setBackground(src) {
  const body = document.querySelector('.body');
  if (src) {
    body.style.backgroundImage = `url(${src})`;
  } else {
    body.classList.add('body_background_second');
  }
}
